<template>
  <div class="home-about-WR" ref="homeAboutWR">
    <img loading="lazy" class="home-about-WR-bg" src="@/assets/img/home/aboutWRImg1.png" alt="">
    <Transition enter-active-class="animate__slideInUp" leave-active-class="animate__slideOutDown">
      <img loading="lazy" class="about-WR-text animate__animated " v-if="offsetTop < 650"
        src="@/assets/img/home/aboutWRText1.png" alt="">
    </Transition>
    <div>
      <img loading="lazy" src="@/assets/img/home/aboutWRImg2.png" alt="" @click="$router.push('/aboutWR')">
      <img loading="lazy" src="@/assets/img/home/aboutWRImg3.png" alt="" @click="$router.push('/aboutWR')">
      <img loading="lazy" src="@/assets/img/home/aboutWRImg4.png" alt="" @click="$router.push('/aboutWR')">
      <img loading="lazy" src="@/assets/img/home/aboutWRImg5.png" alt="" @click="$router.push('/aboutWR')">
    </div>

  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  props: ['offsetTop'],
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang='scss' scoped>
.home-about-WR {
  position: relative;
  height: 62.5rem;
  display: flex;
  justify-content: center;

  .main-title {
    animation: fadeInBottom 2s;
    // opacity: 0;
  }

  @keyframes fadeInBottom {
    from {
      opacity: 0;
      transform: translateY(100%);
    }

    to {
      opacity: 1
    }
  }

  .home-about-WR-bg {
    width: 120rem;
    height: 62.5rem;
  }

  .about-WR-text {
    width: 30.375rem;
    height: 5.3125rem;
    position: absolute;
    top: 3.75rem;
  }

  div {
    display: grid;
    grid-template-columns: repeat(2, 37.5rem);
    grid-template-rows: repeat(2, 18.75rem);
    gap: 4px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -45%);

    img {
      width: 37.5rem;
      height: 18.75rem;
      cursor: pointer;
    }

    &>:hover {
      background: rgba($color: #4dcaf0, $alpha: 0.5);
      -webkit-box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      -moz-box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
      box-shadow: 10px 10px 99px 6px rgba(76, 201, 240, 1);
    }
  }
}
</style>